import React, { useContext, useEffect, useState } from "react";
import Demandas from "../AcreditadosDetalle/Demandas/Demandas";
import ModalAdicionDemanda from "../AcreditadosDetalle/ModalAdicionDemanda/ModalAdicionDemanda";
import Busqueda from "./Busqueda/Busqueda";
import infoSource from "../../util/infoSource";
import AppContext from "../../Context/AppContext";
import "./Demandas.css";
const Acreditados = () => {
  const [datatableDemandas, setDatatableDemandas] = useState({
    columns: [
      {
        label: "",
        field: "objFind",
        width: 0,
      },
      {
        label: "EXP. JUDICIAL",
        field: "AsigDFolioDemanda",
        width: 20,
      },
      {
        label: "NO. EXP",
        field: "AsigDemandaId",
        width: 150,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          className: "itemDemandaNoExp",
        },
      },
      {
        label: "NO. JUZGADO",
        field: "JuzgadoNombre",
        width: 200,
      },
      {
        label: "TIPO JUICIO",
        field: "TipoJuicioNombre",
        width: 270,
      },
      {
        label: "Acciones",
        field: "AsigDemandaIdAC",
        sort: "disabled",
        width: 80,
      },
    ],
    rows: [],
  });
  const [currentRow, setCurrentRow] = useState({});
  const [showModalDemanda, setShowModalDemanda] = useState(false);
  const { checkUserSession, contextAcreditado, changeLoading } =
    useContext(AppContext);
  const infoUs = checkUserSession();
  useEffect(() => {
    loadInfo();
  }, []);
  async function loadInfo() {
    changeLoading(true);
    const listDemandas = await infoSource.Demandas.AllDemandas(infoUs);
    setDatatableDemandas({
      ...datatableDemandas,
      rows: listDemandas.map((item, i) => ({
        objFind: `${item.AsigDfolioDemanda} ${item.AsigDemandaId} ${item.JuzgadoNombre} ${item.TipoJuicioNombre}`,
        AsigDFolioDemanda: (
          <div className={`Gestor_AcreditadoDetalle`}>
            {item.AsigDFolioDemanda}
          </div>
        ),
        AsigDemandaId: item.data.AcreditadoId,
        JuzgadoNombre: item.JuzgadoNombre,
        TipoJuicioNombre: item.TipoJuicioNombre,
        AsigDemandaIdAC: (
          <>
            <button
              className="btnDetalleExpediente"
              onClick={() => {
                setCurrentRow({
                  AsigDemandaId: item.data.AsigDemandaId,
                  JuzgadoId: item.data.JuzgadoId,
                  AcreditadoId: item.data.AcreditadoId,
                  AsigDfolioDemanda: item.data.AsigDfolioDemanda,
                  TipoJuicioId: item.data.TipoJuicioId,
                  AsigDComentarios: item.data.AsigDcomentarios,
                  AsigDstatus: item.data.AsigDstatus,
                  DemGestorId: item.data.DemGestorId,
                  FechaRegistro: item.data.FechaRegistro,
                });
                setShowModalDemanda(true);
              }}
            >
              Editar
            </button>
          </>
        ),
      })),
    });
    changeLoading(false);
  }
  return (
    <>
      <div className="Demandas__container">
        {/* <Busqueda /> */}
        <div className="TituloTablaAcreditado">
          Acreditados <span>Total del listado</span>
        </div>
        <div className="DemandasDataTable__container">
          <Demandas
            setCurrentRow={setCurrentRow}
            setShowModalEdicion={setShowModalDemanda}
            id={-1}
            datatable={datatableDemandas}
          />
        </div>
      </div>
      {showModalDemanda && (
        <ModalAdicionDemanda
          setShow={setShowModalDemanda}
          show={showModalDemanda}
          setCurrentRow={setCurrentRow}
          currentRow={currentRow}
        />
      )}
    </>
  );
};

export default Acreditados;
